module.exports = __webpack_public_path__ + "assets/img/1391587607367_.pic_hd.bbe7ff3c.jpg";